module.exports = __webpack_public_path__ + "media/assets/historyButton-df2450a597884dfa5eb935491abe5ec6.png";